import { Table, Radio, Select, Checkbox } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useState } from 'react';

const { Option } = Select;

interface RowData {
  key: string;
  field: string;
  current: string;
  imported: Array<{ id: string; value: string }> | string;
}

export default function TableWithSelectHeader({ recordParent = {} as any, stData = {} as any, onChange = (data = {}, type = null) => { } }) {
  const [selectedValues, setSelectedValues] = useState<{
    current: string[];
    imported: string[];
  }>({
    current: [],
    imported: [],
  });
  const [selectedAction, setSelectedAction] = useState<string | undefined>();

  const dataRow = [] as any
  const obField = {
    name_dict: 'Tên khách hàng',
    customer_code_dict: 'Mã khách hàng',
    id_card_no_dict: 'CCCD/CMND',
    tel_dict: 'Số điện thoại',
    address_dict: 'Địa chỉ',
  } as any
  Object.keys(recordParent.import_data).map((iskey: any, index: any) => {
    if (obField[iskey]) {
      const imported = [] as any
      if (Object.keys(recordParent.import_data[iskey]).length > 1) {
        const dbstrarr = recordParent.db_data[iskey]
        Object.keys(recordParent.import_data[iskey]).map((item: any, indexItem: any) => {
          // if(dbstrarr && dbstrarr.includes(item)){
          //   return
          // }
          imported.push({
            id: `${index}-${indexItem}`,
            value: recordParent.import_data[iskey][item][0],
            default: recordParent.import_data[iskey][item][1] || false,
            idval: item
          })
        })
      } else {
        if (Object.keys(recordParent.import_data[iskey]).length === 1) {
          imported.push({
            id: `${index}-0`,
            value: recordParent.import_data[iskey][Object.keys(recordParent.import_data[iskey])[0]][0],
            default: recordParent.import_data[iskey][Object.keys(recordParent.import_data[iskey])[0]][1] || false,
            idval: Object.keys(recordParent.import_data[iskey])[0]
          })
        }
      }
      const current = [] as any
      if (Object.keys(recordParent.db_data[`${iskey}_exist`]).length > 1) {
        Object.keys(recordParent.db_data[`${iskey}_exist`]).map((item: any, indexItem: any) => {
          current.push({
            id: `${index}-${indexItem}`,
            value: recordParent.db_data[`${iskey}_exist`][item][0],
            default: recordParent.db_data[`${iskey}_exist`][item][1] || false,
            idval: item
          })
        })
      } else {
        if (Object.keys(recordParent.db_data[`${iskey}_exist`]).length === 1) {
          current.push({
            id: `${index}-0`,
            value: recordParent.db_data[`${iskey}_exist`][Object.keys(recordParent.db_data[`${iskey}_exist`])[0]][0],
            default: recordParent.db_data[`${iskey}_exist`][Object.keys(recordParent.db_data[`${iskey}_exist`])[0]][1] || false,
            idval: Object.keys(recordParent.db_data[`${iskey}_exist`])[0]
          })
        }
      }
      const item = {
        key: iskey,
        field: obField[iskey] || iskey,
        current,
        imported
      }
      if (item.current.length > 0 || item.imported.length > 0) {
        if(iskey === 'customer_code_dict'){
          dataRow.push(item)
        } else {
          if(item.current.length > 1 || item.imported.length > 1){
            dataRow.push(item)
          }
        }
      }
    }
  })

  const data: RowData[] = [
    {
      key: '1',
      field: 'Tên khách hàng',
      current: 'Bùi Thảo Hiền',
      imported: [{
        id: '1-1',
        value: 'Bùi Thị Thảo Hiền'
      }],
    },
    {
      key: '2',
      field: 'Điện thoại',
      current: '0344730000',
      imported: [
        {
          id: '2-1',
          value: '03447301111',
        },
        {
          id: '2-2',
          value: '03447301110',
        },
      ],
    },
    {
      key: '3',
      field: 'CCCD/CMND',
      current: '079199055111',
      imported: [{
        id: '3-1',
        value: '079199055111'
      }],
    },
    {
      key: '4',
      field: 'Email',
      current: 'hien.bui@bluebolt.consulting',
      imported: [{
        id: '4-1',
        value: 'hien.bui@blueboltsoftware.com'
      }],
    },
    {
      key: '5',
      field: 'Ngày sinh',
      current: '01/01/1900',
      imported: [{
        id: '5-1',
        value: '01/01/1900'
      }],
    },
    {
      key: '6',
      field: 'Địa chỉ',
      current: '32 đường số 9, City park',
      imported: [
        {
          id: '6-1',
          value: '166 Xa Lộ Hà Nội',
        },
        {
          id: '6-2',
          value: '1000 Quốc lộ 1A',
        },
      ],
    },
  ];

  const handleRadioChange = (key: string, side: 'current' | 'imported') => {
    setSelectedValues((prev) => {
      const isSelected = prev[side].includes(key);
      const updatedSide = isSelected
        ? prev[side].filter((k) => k !== key)
        : [...prev[side], key];

      return {
        ...prev,
        [side]: updatedSide,
      };
    });
  };


  const columns: ColumnsType<RowData> = [
    {
      title: 'Trường dữ liệu',
      dataIndex: 'field',
      key: 'field',
    },
    {
      title: 'Dữ liệu hiện tại',
      dataIndex: 'current',
      key: 'current',
      render: (_: any, record: any) => {

        const currentValues = record.current as any;

        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            {currentValues.map((item: any, index: number) => (
              <div className="cts-radio-wrapper" key={index}>
                {record.key === 'customer_code_dict' ?
                  <Checkbox
                    checked={(item.default === true && stData.obCheckRadioStep4[`${recordParent.key}_key_${record.key}_idval_${item.idval}`] === undefined) || (stData.obCheckRadioStep4[`${recordParent.key}_key_${record.key}_idval_${item.idval}`] === true)}
                    onChange={(e) => {
                      if(e.target.checked){
                        onChange({
                          obCheckRadioStep4: {
                            ...stData.obCheckRadioStep4,
                            [`${recordParent.key}_key_${record.key}_idval_${item.idval}`]: true
                          }
                        });
                      } else {
                        onChange({
                          obCheckRadioStep4: {
                            ...stData.obCheckRadioStep4,
                            [`${recordParent.key}_key_${record.key}_idval_${item.idval}`]: false
                          }
                        });
                      }
                    }}
                    className='cts-checkbox'
                  >
                    {item.value}
                  </Checkbox>
                  :
                  <Radio
                    checked={(item.default === true && !stData.obCheckRadioStep4[`${recordParent.key}_key_${record.key}`]) || (stData.obCheckRadioStep4[`${recordParent.key}_key_${record.key}`] === `current_${item.idval}`)}
                    onChange={(e) => {
                      onChange({
                        obCheckRadioStep4: {
                          ...stData.obCheckRadioStep4,
                          [`${recordParent.key}_key_${record.key}`]: e.target.checked ? `current_${item.idval}` : undefined
                        }
                      });
                    }}
                    className='cts-radio '
                  >
                    {item.value}
                  </Radio>
                }
              </div>
            ))}
          </div>
        );
      }
    },
    {
      title: (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>Dữ liệu trong tệp nhập liệu</span>
          <Select
            placeholder="Cập nhật"
            value={stData.obChoseStep4[recordParent.key] || 'update'}
            onChange={(value: string) => {
              setSelectedAction(value)
              onChange({
                obChoseStep4: {
                  ...stData.obChoseStep4,
                  [recordParent.key]: value,
                }
              });
            }}
            className='cts-selec-table-in-table d-none'
          >
            <Option value="update">Cập nhật</Option>
            <Option value="new">Tạo mới</Option>
          </Select>
        </div>
      ),
      dataIndex: 'imported',
      key: 'imported',
      render: (_: any, record: RowData) => {

        const importedValues = record.imported as Array<{ id: string; value: string }>;

        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            {importedValues.map((item: any, index) => (
              <div className="cts-radio-wrapper" key={index}>
                {record.key === 'customer_code_dict' ?
                  <Checkbox
                    checked={(item.default === true && stData.obCheckRadioStep4[`${recordParent.key}_key_${record.key}_idval_${item.idval}`] === undefined) || (stData.obCheckRadioStep4[`${recordParent.key}_key_${record.key}_idval_${item.idval}`] === true)}
                    onChange={(e) => {
                      if(e.target.checked){
                        onChange({
                          obCheckRadioStep4: {
                            ...stData.obCheckRadioStep4,
                            [`${recordParent.key}_key_${record.key}_idval_${item.idval}`]: true
                          }
                        });
                      } else {
                        onChange({
                          obCheckRadioStep4: {
                            ...stData.obCheckRadioStep4,
                            [`${recordParent.key}_key_${record.key}_idval_${item.idval}`]: false
                          }
                        });
                      }
                    }}
                    className='cts-checkbox'
                  >
                    {item.value}
                  </Checkbox>
                  :
                  <Radio
                    checked={(item.default === true && !stData.obCheckRadioStep4[`${recordParent.key}_key_${record.key}`]) || (stData.obCheckRadioStep4[`${recordParent.key}_key_${record.key}`] === `imported_${item.idval}`)}
                    onChange={(e) => {
                      onChange({
                        obCheckRadioStep4: {
                          ...stData.obCheckRadioStep4,
                          [`${recordParent.key}_key_${record.key}`]: e.target.checked ? `imported_${item.idval}` : undefined
                        }
                      });
                    }}
                    className='cts-radio'
                  >
                    {item.value}
                  </Radio>
                }
              </div>
            ))}
          </div>
        );
      }
    },
  ];

  return (
    <div className="wrap-table-in-table">
      <Table
        columns={columns}
        dataSource={dataRow}
        pagination={false}
        bordered
      />
    </div>
  );
}
